import React, { useState } from 'react';
import ChartRenderer from './ChartRenderer';
import { NewsFeedItem as NewsFeedItemType } from '../../services/newsFeedService';
import './NewsFeedItem.css';

interface NewsFeedItemProps {
  item: NewsFeedItemType;
}

const NewsFeedItem: React.FC<NewsFeedItemProps> = ({ item }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);

  const handleShowMore = () => {
    setIsExpanded(!isExpanded);
  };

  const handleBookmark = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsBookmarked(!isBookmarked);
    // TODO: Добавить функционал сохранения в закладки
  };

  return (
    <div className="news-feed-item">
      {/* Заголовок и подзаголовок */}
      <div className="news-feed-header">
        <div className="news-feed-title-container">
          <h3 className="news-feed-title">{item.title}</h3>
          <button
            className="bookmark-button"
            onClick={handleBookmark}
            title={isBookmarked ? "Удалить из закладок" : "Добавить в закладки"}
          >
            <i className={`fas ${isBookmarked ? 'fa-bookmark' : 'fa-bookmark-o'}`}></i>
          </button>
        </div>
        {item.subtitle && (
          <p className="news-feed-subtitle">{item.subtitle}</p>
        )}
      </div>

      {/* Теги */}
      <div className="news-feed-tags">
        {item.tags.map((tag, index) => (
          <span key={index} className="news-feed-tag">
            {tag}
          </span>
        ))}
        {item.date && (
          <span className="news-feed-tag news-feed-date">
            {item.date}
          </span>
        )}
        {item.team && (
          <span className="news-feed-tag news-feed-team">
            {item.team}
          </span>
        )}
      </div>

      {/* График (осветлённый, с пометкой демо) */}
      <div className="news-feed-chart-wrapper">
        <div className="news-feed-chart news-feed-chart-dimmed">
          <ChartRenderer 
            type={item.chart_type} 
            data={item.chart_data}
          />
        </div>
        <div className="news-feed-chart-overlay">
          <span className="news-feed-chart-overlay-label">Демонстрационный дашборд</span>
        </div>
      </div>

      {/* Инсайты */}
      {item.insights && item.insights.length > 0 && (
        <div className="news-feed-insights">
          {isExpanded ? (
            <div className="insights-expanded">
              {item.insights.map((insight, index) => (
                <div key={index} className="insight-item">
                  <span className="insight-bullet">•</span>
                  <span className="insight-text">{insight}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="insights-preview">
              <span className="insight-bullet">•</span>
              <span className="insight-text">{item.insights[0]}</span>
              {item.insights.length > 1 && (
                <span className="insights-more">
                  +{item.insights.length - 1} еще
                </span>
              )}
            </div>
          )}
        </div>
      )}

      {/* Кнопка Show more */}
      {item.insights && item.insights.length > 1 && (
        <div className="news-feed-actions">
          <button 
            className="show-more-button"
            onClick={handleShowMore}
          >
            {isExpanded ? 'Скрыть' : 'Показать больше'}
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsFeedItem;
